import { canAddTranscriber, isTranscribing } from '../transcribing/functions';
import { formatCaptionTime } from './captionLocalization';
/**
 * Checks whether the participant can start the subtitles.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean} - True if the participant can start the subtitles.
 */
export function canStartSubtitles(state) {
    return canAddTranscriber(state) || isTranscribing(state);
}
/**
 * Formats the local in-room caption history for transcript display/export.
 *
 * @param {ISubtitleHistoryEntry[]} entries - Caption history entries.
 * @returns {string} Plain transcript text.
 */
export function formatSubtitleHistory(entries = [], options = {}) {
    return entries.map(entry => {
        const time = formatCaptionTime(entry.timestamp, options.language);
        const speaker = entry.participantName || options.unknownSpeaker || 'Unknown speaker';
        const marker = entry.final ? '' : ` (${options.interim || 'interim'})`;
        const label = options.showSpeakerNames === false
            ? (entry.final ? '' : `(${options.interim || 'interim'})`)
            : `${speaker}${marker}`;
        return `[${time}] ${label ? `${label}: ` : ''}${entry.text}`;
    }).join('\n');
}
